import { EntityFilterInterface } from './interfaces/entityFilterInterface.model';
import { Order } from './order.model';

export class Criteria {
    filter: EntityFilterInterface;
    order: Array<Order>;
}
